
const state = {
    cards: {},
};

export default {
    namespaced: true,
    state,
    getters: {
        getList: (state) => state.cards,
        getTotalSelected: (state, getters) =>
            Object.keys(getters.getList).reduce((total, slug) => total + (
                getters.getTotalSelectedBySlug(slug)
            ), 0),
        getTotalSelectedBySlug: (state, getters) => (slug) =>
            getters.getList[slug] ? 
                Object.keys(getters.getList[slug]).reduce((totalBySlug, cardId) => totalBySlug + (
                    getters.getTotalSelectedBySlugAndId(slug, cardId)
                ), 0) :
                [],
        getTotalSelectedBySlugAndId: (state, getters) => (slug, cardId) =>
            getters.getList[slug]?.[cardId] ?
                Object.keys(getters.getList[slug][cardId]).reduce((totalById, style) => totalById + (
                    getters.getList[slug][cardId][style].total_requested
                ), 0) :
                [],
        getTotalPrice: (state, getters) =>
            Object.keys(getters.getList).reduce((total, slug) => total + (
                getters.getTotalPriceBySlug(slug)
            ), 0),
        getTotalPriceBySlug: (state, getters) => (slug) =>
            getters.getList[slug] ?
                Object.keys(getters.getList[slug]).reduce((totalBySlug, cardId) => totalBySlug + (
                    getters.getTotalPriceBySlugAndId(slug, cardId)
                ), 0) :
                [],
        getTotalPriceBySlugAndId: (state, getters) => (slug, cardId) =>
            getters.getList[slug]?.[cardId] ? 
                Object.keys(getters.getList[slug][cardId]).reduce((totalById, style) => totalById + (
                    getters.getList[slug][cardId][style].price * getters.getList[slug][cardId][style].total_requested
                ), 0) :
                [],
        getCardBySlug: (state, getters) => (slug) => getters.getList[slug],
        getCardBySlugAndId: (state, getters) => (slug, id) => getters.getList[slug]?.[id],
    },
    mutations: {
        addPreselectedCardList: (state, cards) => {
            state.cards = cards;
        },
        upsertCards: (state, { slug, condition, quantity }) => {
            const { product_id, style } = condition;

            state.cards = {
                ...state.cards,
                [slug]: {
                    ...state.cards[slug],
                    [product_id]: {
                        ...state.cards[slug][product_id],
                        [style]: {
                            ...condition,
                            total_requested: quantity,
                        }
                    },
                },
            };
        },
        removeCards: (state, { slug, condition }) => {
            const { product_id, style } = condition;

            if (state.cards[slug]?.[product_id]?.[style]) {
                state.cards[slug][product_id][style].total_requested = 0;
            }
        },
    },
    actions: {
        addPreselectedCardList: ({ commit }, value) => {
            const preSelectedCards = value.reduce((acumm, cardGroup) => {
                const preSelectedOptions = {};

                cardGroup.forEach((card) => {
                    card.style_qty?.forEach((cardStyle) => {
                        if (cardStyle.total_requested > 0) {
                            preSelectedOptions[cardStyle.product_id] = {
                                ...preSelectedOptions[cardStyle.product_id],
                                [cardStyle.style]: cardStyle
                            }
                        }
                    })
                });

                return {
                    ...acumm,
                    [cardGroup[0].clean_slug]: preSelectedOptions
                };
            }, {});

            commit('addPreselectedCardList', preSelectedCards);
        },
        removeCards: ({ commit }, value) =>
            commit('removeCards', value),
        upsertCards: ({ commit }, value) =>
            commit('upsertCards', value),
    },

}